const initSmoothScrolls = () : void => {
  const smoothScrolls = document.querySelectorAll('[data-smooth-scroll]');
  if (!smoothScrolls || smoothScrolls.length < 1) {
    return
  }
  smoothScrolls.forEach(el => {
    el.addEventListener('click', (evt) => {
      
      evt.preventDefault();
      const selector = el.getAttribute('href')
      const target = document.querySelector(selector)
      target.scrollIntoView({ behavior: 'smooth' })
    })  
  });
}

export default initSmoothScrolls